import { fetchFromAPI } from 'utils/api';

export function getDCAssetImageTags(assetId) {
  return fetchFromAPI(`/daily_checkup_assets/${assetId}/image_tags`).catch((errors) => {
    throw errors;
  });
}
